import { getStatusLabel } from "@@/core/libraries/adminFunctions";
import Loading from "@@/core/components/shared/Loading/Loading";
import OrderStatus from "@@/core/components/order/OrderStatus/OrderStatus";
import mixins from "@@/core/mixins/mixins";

import { BButton, BCard, BTable, BCollapse, BFormGroup, VBToggle } from "bootstrap-vue";

export default {
  name: "order",
  components: {
    Loading,
    OrderStatus,
    BButton,
    BCard,
    BTable,
    BCollapse,
    BFormGroup,
  },
  mixins: [mixins],
  directives:{
    'b-toggle' :VBToggle
  },
  data() {
    return {
      url: "admin/orders",
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "user",
          label: "مشتری",
        },
        {
          key: "receiver",
          label: "گیرنده",
        },
        {
          key: "total_products_prices_with_discount",
          label: "مبلغ کل",
        },
        {
          key: "status",
          label: "وضعیت",
        },
        {
          key: "created_at",
          label: "تاریخ ثبت",
        },
        {
          key: "detail",
          label: "جزئیات",
        },
      ],
      order: {},
      filter: {
        customer: null,
        start_date: "",
        end_date: "",
      },
    };
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    getStatusLabel,
    resetFilter() {
      this.filter = this.$options.data.apply(this).filter;
    },
    getReceiverName(orderAddress) {
      if (orderAddress) {
        return `${orderAddress.first_name} ${orderAddress.last_name} - ${orderAddress.mobile}`;
      } else {
        return "نا مشخص";
      }
    },
    getUserInfo(orderUser) {
      if (orderUser) {
        return `${orderUser.first_name} ${orderUser.last_name} - ${orderUser.mobile}`;
      } else {
        return "نا مشخص";
      }
    },
    async filterItem() {
      this.searchParams = {
        user_id: this.filter.customer ? this.filter.customer.id : "",
        start_date: this.filter.start_date
          ? this.filter.start_date
          : "",
        end_date: this.filter.end_date
          ? this.filter.end_date
          : "",
      };
    },
  },
};
